import { render, staticRenderFns } from "./IconTypeformDropdown.vue?vue&type=template&id=4d0c1a5c&"
import script from "./IconTypeformDropdown.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports